// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";
// import statusHouseCertification from "../../assets/table_8-6-24.png";


// export default function StatusHouseCertification() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                         <div>

//                   <h1>Export House Certificate</h1>
            
//                     <h2>What is a Status Holder?</h2>
//                     <p> According to the Foreign Trade Policy, Indian exporters of goods and services are assigned status holder positions based on their export performance.</p>
//                     <p>You can be a status holder if you have risen to the top of your industry and have a proven track record in international trade. You must have contributed significantly to India's overseas trade. You must also commit to assist aspiring Indian businesses in order to strengthen India's exportrelated industry.</p>
                    
//                     <h2>Criteria for Eligibility</h2>
//                     <p>To be recognised as a "status holder exporter," an exporter must meet the following criteria: The valid Import – Export Code must be provided by the applicant for the Star Export House grant (IEC).</p>
//                         <p>The certificate is provided based on the exporters' achievement of a specified level of export performance.</p>
//                         <p>The applicant can be recognised as a status holder in one of five categories, ranging from One Star Export House to Five Star Export House. The FOB/FOR value of their export performance should be $3 million, $15 million, $50 million, $200 million, and $800 million, respectively.</p>
//                         <p>An applicant shall be categorized as status holder on achieving export performance during the current and previous three financial years (for Gems& Jewellery Sector the performance during the current and previous two financial years shall be considered for recognition as status holder) as indicated in paragraph 3.21 of Foreign Trade Policy.</p>
//                         <p>For granting status, export performance is necessary in in all the three preceding financial years (and in all the two preceding financial years for Gems & Jewelry Sector).</p>
                              
//                     </div>
//                  </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
            
//         <Row className="g-4 align-items-start">
//                           {/* LEFT CONTENT */}
//                        <Col lg={8}>
//                               <div>
//                                   <p>The applicant can be recognised as a status holder in one of five categories, ranging from One Star Export House to Five Star Export House. The FOB/FOR value of their export performance should be $3 million, $25 million, $100 million, $500 million, and $2000 million, respectively.</p>
//                                 <p>An applicant shall be categorized as status holder on achieving export performance during the current and previous three financial years (for Gems& Jewellery Sector the performance during the current and previous two financial years shall be considered for recognition as status holder) as indicated in paragraph 3.21 of Foreign Trade Policy.</p>
//                                 <p>For granting status, export performance is necessary in at least two out of four years.</p>
//                        </div>
                              

//                           </Col>
//                           <Col lg={4}>
//                               <div>
//                                   <img src={statusHouseCertification} alt="Status House Certification" className="img-fluid" />
//                               </div>
//                           </Col>
//                       </Row>
                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <h2>Benefits</h2>
//                                   <ul>
//                                       <li>Authorisation and Customs Clearances for both imports and exports may be granted on self-declaration basis;</li>
//                                       <li>Input-Output norms may be fixed on priority within 60 days by the Norms Committee ;Special scheme in respect of Input Output Norms to be notified by DGFT from time to time, for specified status holder</li>
//                                       <li>Exemption from furnishing of Bank Guarantee for Schemes under FTP, unless specified otherwise anywhere in FTP or HBP;</li>
//                                       <li>Exemption from compulsory negotiation of documents through banks. Remittance / receipts, however, would be received through banking channels;</li>
//                                       <li>Two star and above Export houses shall be permitted to establish Export Warehouses as per Department of Revenue guidelines.</li>
//                                       <li>Three Star and above Export House shall be entitled to get benefit of Accredited Clients Programme (ACP) as per the guidelines of CBEC (website: http://cbec.gov.in).</li>
//                                       <li>The status holders would be entitled to preferential treatment and priority in handling of their consignments by the concerned agencies.</li>
//                                       <li>Manufacturers who are also status holders (Three Star/Four Star/Five Star) will be enabled to self certify their manufactured goods (as per their IEM/IL/LOI) as originating from India with a view to qualify for preferential treatment under different preferential trading agreements (PTA), Free Trade Agreements (FTAs), Comprehensive Economic Cooperation Agreements (CECA) and Comprehensive Economic Partnership Agreements (CEPA). Subsequently, the scheme may be extended to remaining Status Holders.</li>
//                                       <li>Manufacturer exporters who are also Status Holders shall be eligible to self-certify their goods as originating from India as per Para 2.108 (d) of Hand Book of Procedures.</li>
//                                       <li>Status holders shall be entitled to export freely exportable items (excluding Gems and Jewellery, Articles of Gold and precious metals) on free of cost basis for export promotion subject to an annual limit as below:</li>
//                                   </ul>
//                                   <p>A. Annual limit of 2% of average annual export realization during preceding three licensing years for all exporters (excluding the exporters of following sectors-(1) Gems and Jewellery Sector, (2) Articles of Gold and precious metals sector).</p>
//                                   <p>B. Annual limit of Rupees One Crore or 2% of average annual export realization during preceding three licensing years, whichever is lower. (for exporters of the following sectors-(1) Gems and Jewellery Sector, (2) Articles of Gold and precious metals sector).</p>
//                                   <p>C. In case of supplies of pharmaceutical products, vaccines and lifesaving drugs to health programmes of international agencies such as UN, WHOPAHO and Government health programmes, the annual limit shall be upto 8% of the average annual export realisation during preceding three licensing years.</p>
//                                   <p>The free of cost supplies made under provisions of Para 3.24(j) shall not be entitled to Duty Drawback or any other export incentive under any export promotion scheme.vi</p>
//                                   <h2>Documentation simplicity and preferential treatment</h2>
//                                   <p>Compulsory negotiation exempted export documentation from going through banks, and entitled import-export consignments to preferential treatment and priority.</p>
                              
//                                   <h2>Double-weighted concept for obtaining a One Star Export House Certificate:</h2>
//                                   <p>Only one-star export houses meet the criterion for earning double weighting. This does not apply to other groups of status holders.</p>
                                  
//                                   <h2>Criteria for Double Weighting</h2>
//                                   <p>An exporter who meets any of the following requirements is eligible for double weightage:</p>
//                                   <ul>
//                                       <li>Micro, Small & Medium Enterprises (MSME) as defined in Micro, Small & Medium Enterprises Development (MSMED) Act 2006.</li>
//                                        <li>Manufacturing units having ISO/BIS.</li>
//                                        <li>Units located in North Eastern States including Sikkim and Jammu & Kashmir.</li>
//                                        <li>Units located in Agri Export Zones.</li>
//                                   </ul>
//                                   <p>By the way, the issuance of double weightage is limited to the One Star Export House Status category.</p>
                              
//                                   <h2>Validity of status certificate</h2>
//                                   <ul>
//                                       <li>(a) Any Status Certificate issued under FTP 2015-20 to an IEC holder shall remain valid only till 30.09.2023.</li>
//                                       <li>(b) Status Certificates issued under this FTP shall be valid for a period of 5 years from the date on which application for recognition was filed.</li>
//                                       <li>(c) On achieving higher status threshold as per Para 1.26 of FTP a firm can, at its discretion, upgrade their status holder category after surrender of the previous Certificate and applying as per para 1.08 above.</li>
//                                   </ul>
//                                   <h2>How do you calculate the status holder certificate's export performance?</h2>
//                                   <p>The current year's export performance, as well as the previous three years', will be calculated; it will be counted based on FOB value of export earnings in free foreign exchange, with deemed exports also being counted based on FOR value. Earnings in rupees will be converted into US dollars at the CBEC (Central Board of Excise and Customs) rate in effect on April 1st of each fiscal year.</p>

//                                   <h2>Important Note on Export Performance Calculation</h2>
//                                   <p>You cannot transfer or get your export performance from another IEC holder. Hence, calculation of exports performance based on disclaimer shall not be allowed. Re-export basis exports shall not be counted for recognition. However, products connected to Special Chemicals, Organisms, Materials, Equipment, and Technologies (SCOMET) as well as other things under Authorisation do count toward determining your export performance.</p>

//                                   <h2>Refusal/Suspension/Cancellation of Certificate</h2>
//                                   <p>A status certificate may be refused/suspended/cancelled by the RA concerned if the status holder or an authorised representative acting on his behalf: (a) fails to fulfil the export obligation; (b) tampers with Authorisations; (c) misrepresents or has been a party to any corrupt or fraudulent practise in obtaining any Authorisation; (d) commits a breech of the FT(D&R) Act, or Rules, Orders made there under and FTP, The Customs Act 1962, The Central Excise Act 1944, FEMA Act 1999 and COFEPOSA Act 1974; or (e) fails to furnish information required by the Directorate.</p>
//                                   <p>Before taking any action, the Status Holder must be given a reasonable opportunity.</p>
//                                   <p>At Apex Services What We Do</p>
//                                   <p>Apex Services will also help you with Consultation for Status House Certificate, The certification issues under Foreign Trade Policy to an IEC holder. Applicants will have to register online for the status house certificate. Our professional experts will be giving you the guidelines and providing you with the pathway for the submission of the scanned prescribed documents, digital signature followed by jurisdictional RA/Development Commissioner (DC) by Registered Office in the case of Company and by Head Office. From appealing to the validity of the status certificate, we commence right from the scratch.</p>
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaIndustry,
  FaHandsHelping,
  FaExclamationTriangle
} from "react-icons/fa";

export default function StarExportHouse() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">
            <Col lg={8}>
              <h1>
                Star Export House Certificate
              </h1>

              <p>
                The Star Export House Certificate is a prestigious recognition
                issued by DGFT to exporters with strong export performance and
                consistent foreign exchange earnings.
              </p>

              <p>
                It enhances your global credibility, improves trust with buyers,
                and provides access to exclusive export benefits and faster approvals.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form */}
            </Col>
          </Row>

          {/* WHAT IS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> What is Star Export House?
          </h2>

          <p>
            Star Export House status is awarded to businesses that meet defined
            export performance criteria under India’s Foreign Trade Policy.
            It recognizes exporters as reliable and high-performing global suppliers.
          </p>

          {/* WHY IMPORTANT */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Why It Matters
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Builds strong international reputation</li>
            <li><FaCheckCircle /> Enhances buyer trust and credibility</li>
            <li><FaCheckCircle /> Provides access to export incentives</li>
            <li><FaCheckCircle /> Enables faster approvals and clearances</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Benefits of Star Export House
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Priority customs clearance</li>
            <li><FaCheckCircle /> Reduced documentation requirements</li>
            <li><FaCheckCircle /> Access to schemes like EPCG & DFIA</li>
            <li><FaCheckCircle /> Export credit and financial support</li>
            <li><FaCheckCircle /> Better global market access</li>
            <li><FaCheckCircle /> Stronger business partnerships</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Eligibility Criteria
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Minimum export turnover as per FTP</li>
            <li><FaCheckCircle /> Consistent export performance</li>
            <li><FaCheckCircle /> Compliance with tax and regulations</li>
            <li><FaCheckCircle /> Valid IEC registration</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Prepare export and financial documents</li>
            <li><FaCheckCircle /> Submit application on DGFT portal</li>
            <li><FaCheckCircle /> Verification by DGFT authorities</li>
            <li><FaCheckCircle /> Certificate issuance</li>
          </ul>

          <p><strong>Processing Time:</strong> 15–30 days</p>

          {/* DOCUMENTS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Documents Required
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> IEC Certificate</li>
            <li><FaCheckCircle /> Export turnover details (FOB)</li>
            <li><FaCheckCircle /> CA certified statements</li>
            <li><FaCheckCircle /> Shipping bills and export records</li>
            <li><FaCheckCircle /> GST and compliance documents</li>
          </ul>

          {/* MISTAKES */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Common Mistakes
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Incorrect export data submission</li>
            <li><FaCheckCircle /> Missing CA certification</li>
            <li><FaCheckCircle /> Incomplete documentation</li>
            <li><FaCheckCircle /> Not meeting eligibility criteria</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete assistance including
            eligibility assessment, documentation support, application filing,
            and continuous follow-ups with DGFT to ensure quick and successful approval.
          </p>

        </Container>
      </section>
    </div>
  );
}